module.exports = __webpack_public_path__ + "static/media/998130.b8afe927.png";